import { GradeMajor } from "../types";

export const majorsList: GradeMajor[] = [
  "science",
  "scienceMath",
  "scienceBiology",
  "literature",
];
